"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Tab_1 = tslib_1.__importDefault(require("@mui/material/Tab"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const SidebarTab = (props) => {
    const { icon, 
    /* textColor is passed down by the Tabs component, but not used.
     * it causes warnings in the console similar to:
     * 'React does not recognize the `textColor` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as
     * lowercase `textcolor` instead. If you accidentally passed it from a parent component, remove it from the DOM element.'
     * to avoid the console warning it is thrown away here. The textColor is not used since the styles of this component defines the colors of the icons
     */
    textColor, TooltipProps, tooltipTitle, value, ...restProps } = props;
    const contentEl = (react_1.default.createElement(Tab_1.default, { value: value, icon: icon, sx: theme => ({
            height: theme.spacing(7),
            minHeight: "unset",
            minWidth: theme.spacing(7),
            opacity: 1,
            width: theme.spacing(7),
            color: theme.palette.action.active,
            "&.Mui-selected": {
                color: theme.palette.primary.main,
            },
        }), ...restProps }));
    return tooltipTitle || TooltipProps ? (react_1.default.createElement(Tooltip_1.default, { title: tooltipTitle, ...TooltipProps }, contentEl)) : (contentEl);
};
exports.default = SidebarTab;
